import { useState, Fragment, useEffect } from 'react';
import { useNavigate } from 'react-router';
import Cam from '../../assets/icons/Cam';
import ThumbsDown from '../../assets/icons/ThumbsDown';
import ThumbsUp from '../../assets/icons/ThumbsUp';
import InputDropdown from '../../components/InputDropdown/InputDropdown';
import axios from 'axios';
import RightArrow from '../../assets/icons/RightArrow';
import Button from '../../components/Button/Button';
import { notification, message } from 'antd';
import { time } from '../../data';
import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';
import { durationTypes } from '../../data';
import moment from 'moment';

import { getTeacherTopics } from '../../services/learnService';
import Info from '../../assets/icons/Info';
import { baseURL } from '../../utils/axios';

const CreateLiveClass = () => {
  const navigate = useNavigate();

  const [dropDown, setDropDown] = useState(false);
  const [schedules, setSchedules] = useState([]);
  const [currentSelect, setCurrentSelect] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedLesson, setSelectedLesson] = useState('');
  const [selectedDay, setSelectedDay] = useState('');
  const [selectedDays, setSelectedDays] = useState('');
  const [courses, setCourses] = useState('');
  const [classType, setClassType] = useState('group');
  const [durationType, setDurationtype] = useState('Weeks');
  const [dropdowns, setDropdowns] = useState({
    duration: false,
    days: false,
  });
  const [updateData, setUpdateData] = useState({
    duration: '',
    startDate: '',
  });

  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const [nextWeek, setNextWeek] = useState('');
  const [count, setCount] = useState(1);

  let token = localStorage.getItem('token');
  let userData = JSON.parse(localStorage.getItem('userData'));

  //axios headers
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json; charset=utf-8',
    },
  };

  const getToday = (date) => {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [month, day, year].join('/');
  };

  const getEndDate = () => {
    var today = new Date();
    var nextweek = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + 7 * updateData.duration
    );
    let formattedEndDate = moment(nextweek).format('L');

    return formattedEndDate;
  };

  const getSClasses = async () => {
    let user = JSON.parse(localStorage.getItem('userData'));
    let res = await getTeacherTopics();

    // let res = await getCourses(user.id);
    setCourses(res.data.topics);
  };

  useEffect(() => {
    getSClasses();
  }, []);

  const saveSchedule = async () => {
    let formattedStartDate = getToday(updateData.startDate);
    let formattedEndDate = getEndDate();

    getEndDate();

    let courseid = selectedLesson.course.id;
    let payload = {
      learningFocus: selectedLesson?.title,
      groupClass: classType === 'group' ? true : false,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      schedules: schedules.filter((el) => el?.startTime && el?.endTime),
    };

    try {
      setLoading(true);
      let res = await axios.post(
        `${baseURL}/teachers/${userData.id}/courses/${courseid}/live-classes`,
        payload,
        config
      );

      navigate('/tutor/live-classes');
      notification['success']({
        message: res.data.message,
      });

      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error(error.response.data.message);
      notification['error']({
        message: error.response.data.message,
      });
    }
  };

  const handleChange = (evt) => {
    const value = evt.target.value;
    const name = evt.target.name;
    setUpdateData({
      ...updateData,
      [name]: value,
    });
  };

  function getNextWeek() {
    var today = new Date();
    var nextweek = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + 7 * updateData.duration
    );
    let formattedNextWeek = moment(nextweek).format('MMMM Do YYYY');

    setNextWeek(formattedNextWeek);
  }

  let schedule = {};

  const pickScheduleDay = (day) => {
    schedule.day = day;
  };

  const pushSelectedDay = (day) => {
    setSelectedDays([...selectedDays, day]);
    setLoading(true);
    setLoading(false);
  };

  return (
    <>
      <DashboardHeader tutor />
      <div style={{ background: '#F8F8F8', padding: '32px 132px' }}>
        <p>
          <span
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/dashboard')}
          >
            {' '}
            Home
          </span>{' '}
          |{' '}
          <span onClick={() => navigate('/tutor/live-classes')}>
            Live Class
          </span>{' '}
          | Schedule Live Class
        </p>
        <div className='card-bg'>
          <div className='schedule'>
            <div className='schedule__heading'>
              <div className='schedule__heading__icon'>
                <Cam />
              </div>
              <h3>Schedule live class</h3>
            </div>
            <div className='schedule__subheading'>
              <p>
                Your students can only schedule an appointment based <br /> on
                your available days and times
              </p>
            </div>
            <div className='schedule__form'>
              <div
                className='auth-wrapper__right__form__inputwrapper eye-position'
                style={{ width: '100%', cursor: 'pointer' }}
                onClick={() => setDropDown(!dropDown)}
              >
                <div
                  style={{ display: 'flex', gap: '8px', alignItems: 'center' }}
                >
                  <div className='dot'></div>
                  <label htmlFor='subject'>Subject-class name</label>
                </div>

                <input
                  type='text'
                  name='subject'
                  id='subject'
                  placeholder='What class do you want to create this schedule for?'
                  value={selectedLesson?.title}
                  disabled
                />

                <div className='eye-icon'>
                  <RightArrow />
                </div>
              </div>
              {dropDown && (
                <InputDropdown
                  arr={courses.length > 0 ? courses : []}
                  setSelectedLesson={setSelectedLesson}
                  setSelectedLessonId={() => pickScheduleDay(selectedLesson)}
                  closeDropdown={() => setDropDown(false)}
                />
              )}

              <div
                className='auth-wrapper__right__form__inputwrapper'
                style={{ width: '100%', marginTop: '16px' }}
              >
                <label htmlFor='lastName'>
                  What type of live class is this lesson?
                </label>
                <div className='flex-to-column'>
                  {' '}
                  <button
                    className='live-class-type'
                    onClick={() => setClassType('group')}
                  >
                    {classType === 'group' ? <ThumbsUp /> : <ThumbsDown />}
                    <p className={classType === 'group' ? 'bold' : 'faint'}>
                      Group Class
                    </p>
                  </button>
                  <button
                    className='live-class-type'
                    onClick={() => setClassType('one')}
                  >
                    {classType === 'one' ? <ThumbsUp /> : <ThumbsDown />}
                    <p className={classType === 'one' ? 'bold' : 'faint'}>
                      One- on- one class
                    </p>
                  </button>
                </div>
                {classType === 'group' && (
                  <div
                    style={{
                      display: 'flex',
                      gap: '10px',
                      alignItems: 'center',
                    }}
                  >
                    <Info />{' '}
                    <p>
                      Live classes for this subject can admit a maximum of ten
                      (10) students
                    </p>
                  </div>
                )}
              </div>

              <div
                className='auth-wrapper__right__form__inputwrapper eye-position'
                style={{ width: '100%', cursor: 'pointer' }}
              >
                <div
                  style={{ display: 'flex', gap: '8px', alignItems: 'center' }}
                >
                  <label htmlFor='start-date'>Start date of live class</label>
                </div>

                <input
                  type='date'
                  name='startDate'
                  id='startDate'
                  onChange={handleChange}
                  min={new Date().toISOString().split('T')[0]}
                />
              </div>

              <div
                className='auth-wrapper__right__form__inputwrapper eye-position'
                style={{ width: '100%' }}
              >
                <label htmlFor='subject'>Live class duration</label>
                <div className='select-input'>
                  <div className='dropdown-wrapper'>
                    <div
                      className='select'
                      //   onClick={() => {
                      //     dropdowns.duration
                      //       ? setDropdowns({ ...dropdowns, duration: false })
                      //       : setDropdowns({ ...dropdowns, duration: true });
                      //   }}
                    >
                      <p>{durationType}</p>
                      <RightArrow />
                    </div>
                    {dropdowns.duration && (
                      <div className='dropdown-wrapper__dropdown'>
                        {durationTypes.map((el, idx) => (
                          <div
                            className='dropdown-wrapper__dropdown__item'
                            key={idx}
                            onClick={() => {
                              setDurationtype(el);
                              setDropdowns({ ...dropdowns, duration: false });
                            }}
                          >
                            <p>{el}</p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <input
                    type='number'
                    name='duration'
                    id='class'
                    onChange={handleChange}
                    placeholder='Enter number'
                    onBlur={() => getNextWeek()}
                  />
                </div>
                {nextWeek !== '' && (
                  <div
                    style={{
                      display: 'flex',
                      gap: '10px',
                      alignItems: 'center',
                    }}
                  >
                    <Info /> <p>Live class for this subject ends {nextWeek}</p>
                  </div>
                )}
              </div>
              {Array(count)
                .fill(count)
                .map((el, id) => (
                  <>
                    <div
                      className='auth-wrapper__right__form__inputwrapper eye-position'
                      style={{ width: '100%', cursor: 'pointer' }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <label htmlFor='subject'>Day of live class</label>
                        {/* <div
                          onClick={() => {
                            setSchedules(
                              schedules.filter((el, idx) => idx !== id)
                            );
                            setCount(count - 1);
                          }}
                        >
                          <Delete />
                        </div> */}
                      </div>

                      <input
                        type='text'
                        name='subject'
                        id='subject'
                        placeholder='What class do you want to create this schedule for?'
                        value={
                          loading
                            ? 'Setting day...'
                            : !schedules[id]?.day
                            ? selectedDay
                            : schedules[id]?.day
                        }
                        disabled
                      />

                      <div
                        className='eye-icon'
                        onClick={() => {
                          setCurrentSelect(id);
                          setDropdowns({
                            ...dropdowns,
                            days: dropdowns.days ? false : true,
                          });
                        }}
                      >
                        <RightArrow />
                      </div>
                    </div>
                    {dropdowns.days && currentSelect === id && (
                      <div className='input-dropdown'>
                        {[
                          { title: 'Monday', id: 1 },
                          { title: 'Tuesday', id: 2 },
                          { title: 'Wednesday', id: 3 },
                          { title: 'Thursday', id: 4 },
                          { title: 'Friday', id: 5 },
                          { title: 'Saturday', id: 6 },
                          { title: 'Sunday', id: 7 },
                        ]?.map((el) => (
                          <div
                            className='input-dropdown__item'
                            key={el?.id}
                            onClick={() => {
                              // pushSelectedDay(el.title);
                              setSelectedDay(el.title);
                              schedules.length > 0
                                ? (schedules[id].day = el.title)
                                : (schedule.day = el.title);
                              setDropdowns({
                                ...dropdowns,
                                days: dropdowns.days ? false : true,
                              });
                            }}
                          >
                            <p>{el?.title}</p>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* {dropdowns.days && count - 1 === id && (
                      <InputDropdown
                        arr={[
                          { title: 'Monday', id: 1 },
                          { title: 'Tuesday', id: 2 },
                          { title: 'Wednesday', id: 3 },
                          { title: 'Thursday', id: 4 },
                          { title: 'Friday', id: 5 },
                        ]}
                        setSelectedLesson={setSelectedDay}
                        setSelectedLessonId={setSelectedDayId}
                        closeDropdown={() => {
                          pushSelectedDay();
                          setDropdowns({
                            ...dropdowns,
                            days: dropdowns.days ? false : true,
                          });
                        }}
                      />
                    )} */}

                    <div className='time-select' style={{ marginTop: '0' }}>
                      <div
                        className='auth-wrapper__right__form__inputwrapper eye-position'
                        style={{ width: '100%' }}
                      >
                        <label htmlFor='start'>Start Time</label>
                        <select
                          name='start'
                          id='start'
                          onChange={(e) =>
                            (schedule.startTime = e.target.value)
                          }
                        >
                          <option value=''>00:00</option>
                          {time.map((el) => (
                            <option value={el.time} key={el.id}>
                              {el.time}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div
                        className='auth-wrapper__right__form__inputwrapper eye-position'
                        style={{ width: '100%' }}
                      >
                        <label htmlFor='day'>End time</label>
                        <select
                          name='end'
                          id='end'
                          onChange={(e) => {
                            schedule.endTime = e.target.value;
                            schedule.day = selectedDay;
                            setSchedules([...schedules, schedule]);
                          }}
                          // onBlur={(e) => {
                          //   schedule.endTime = e.target.value;
                          //   schedule.day = selectedDay;
                          //   setSchedules([...schedules, schedule]);
                          // }}
                        >
                          <option value=''>00:00</option>
                          {time.map((el) => (
                            <option value={el.time} key={el.id}>
                              {el.time}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </>
                ))}

              <div className='add-more' onClick={() => setCount(count + 1)}>
                {' '}
                <svg
                  width='14'
                  height='14'
                  viewBox='0 0 14 14'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path d='M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z' fill='#FEA82F' />
                </svg>
                <p>Add Day and Time</p>
              </div>
            </div>
          </div>
          <div className='schedule-footer'>
            <div className='add-more'>
              <p style={{ color: '#161410' }} onClick={() => navigate(-1)}>
                Cancel
              </p>
            </div>
            <div className='schedule-footer__btns'>
              {/* <Button text='Save' className={'orange-border'} /> */}
              <Button
                text='Save Live Class'
                className={'primary-btn'}
                disabled={
                  loading || selectedLesson === '' || schedules.length == 0
                }
                onClick={() => saveSchedule()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateLiveClass;
